import VideoWrapper from "../VideoWrapper/VideoWrapper";
import VideoBackground from "../../../../assets/images/subscribe-now-video-image.png";

export default function RegisterNow() {
  return (
    <div className="h-full flex flex-col gap-4 py-4 border-2 w-full relative">
      <VideoWrapper
        src="https://myfirstjob.blob.core.windows.net/webapp/video_subscribe.mp4"
        light={VideoBackground}
      />
    </div>
  );
}
